import { render, staticRenderFns } from "./sale-quotation-print.vue?vue&type=template&id=68aa4d4c"
import script from "./sale-quotation-print.vue?vue&type=script&lang=js"
export * from "./sale-quotation-print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports